import { isEmpty } from 'lodash';

function isAutoRecallable(referral = {}) {
  return !isEmpty(referral.auto_recall_id);
}

export default isAutoRecallable;
